const padLeftZero = str => ('00' + str).substr(str.length)

/**
 * 时间格式化
 * 示例：
 * formatDate(1571891640000, 'yyyy-MM-dd hh:mm:ss')
 *   ==> '2019-10-24 12:33:51'
 */
export const formatDate = (oldDate, fmt) => {
    let date = new Date()
    if (typeof oldDate === 'string' || typeof oldDate === 'number') {
        date = new Date(+oldDate)
    } else {
        date = oldDate
    }
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    let o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds(),
    }
    let k = null
    for (k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
            let str = o[k] + ''
            fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str))
        }
    }
    return fmt
}
